module.exports = __webpack_public_path__ + "static/media/download.1e4ee9bc.svg";